// import { Loader } from '@googlemaps/js-api-loader';

function initMap(lat, lng) {
    const myLatLng = {lat, lng};
    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 8,
        center: myLatLng,
    });
    new google.maps.Marker({
        position: myLatLng,
        map,
        title: "Hello World!",
    });
}

//Get the exact address
$(".get-address").click(function (event) {
    let postcode = $('#postcode').val()
    let number = $('#number').val()
    $.ajax({
        url: "/erp/admin/get-address/" + postcode + "/" + number,
        type: "GET",
        success: function (response) {
            $('.address').val(response.address.addresses)
            //Show on map
            initMap(response.address.latitude, response.address.longitude)
        },
    });
});




//Get the exact address
$(".get-address-frontside").click(function (event) {
    let postcode = $('#postcode').val()
    let number = $('#number').val()
    $.ajax({
        url: "/erp/get-address/" + postcode + "/" + number,
        type: "GET",
        success: function (response) {
            $('.address').val(response.address.addresses)
            //Show on map
            initMap(response.address.latitude, response.address.longitude)
        },
    });
});
